import React, { useState } from "react";
import api from "../../api";

const SafariZoneModal = ({ isOpen, toggle, playerPos, spawnText, onAccessGranted }) => {
  const [isLoading, setIsLoading] = useState(false);

  if (!isOpen) return null;

  const handlePurchase = async () => {
    setIsLoading(true);
    
    try {
      const response = await api.post("/v1/safari-zone/purchase", {}, { withCredentials: true });
      
      // Close modal immediately
      toggle();
      
      if (response.data.success) {
        // Show floating text for successful purchase
        spawnText("Safari Zone access purchased!", playerPos.x, playerPos.y - 20, "#4CAF50");
        spawnText("-1,000 coins", playerPos.x, playerPos.y, "#f44336");
        
        // Call the callback to handle teleportation and access
        if (onAccessGranted) {
          onAccessGranted(response.data);
        }
      } else {
        // Show error message
        spawnText(response.data.message, playerPos.x, playerPos.y - 20, "#f44336");
      }
    } catch (error) {
      console.error("Error purchasing Safari Zone access:", error);
      const errorMessage = error.response?.data?.detail || "Failed to purchase Safari Zone access";
      spawnText(errorMessage, playerPos.x, playerPos.y - 20, "#f44336");
      toggle();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div 
      className="game-popup-overlay"
      onClick={toggle}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px 10px',
        boxSizing: 'border-box',
        zIndex: 1050
      }}
    >
      <div 
        className="safari-zone-popup"
        onClick={(e) => e.stopPropagation()}
        style={{
          width: '95%',
          maxWidth: 500,
          maxHeight: '95vh',
          background: 'linear-gradient(to bottom, rgba(29, 34, 46, 0.95), rgba(41, 50, 65, 0.95))',
          color: '#fff',
          borderRadius: 12,
          backdropFilter: 'blur(10px)',
          border: '2px solid rgba(255, 255, 255, 0.1)',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          margin: '10px'
        }}
      >
        {/* Header */}
        <div style={{
          padding: '12px 16px',
          borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          background: 'rgba(0, 0, 0, 0.2)',
          flexWrap: 'wrap',
          gap: '8px',
          minHeight: '60px'
        }}>
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '8px',
            flex: '1 1 auto',
            minWidth: '200px'
          }}>
            <h3 style={{ 
              margin: 0, 
              fontSize: '18px', 
              fontWeight: 'bold',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }}>Safari Zone Access</h3>
          </div>
          
          <button
            onClick={toggle}
            style={{
              background: 'rgba(255, 255, 255, 0.1)',
              border: 'none',
              color: '#fff',
              borderRadius: '4px',
              padding: '6px 12px',
              cursor: 'pointer',
              transition: 'all 0.2s',
              fontSize: '14px'
            }}
            onMouseOver={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.2)'}
            onMouseOut={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.1)'}
          >
            Close
          </button>
        </div>

        {/* Content */}
        <div style={{
          padding: '20px',
          overflowY: 'auto',
          flex: 1
        }}>
          <div style={{
            background: 'rgba(0, 0, 0, 0.2)',
            borderRadius: '8px',
            padding: '16px',
            marginBottom: '16px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center'
          }}>
            <img 
              src="/items/pokeball.png" 
              alt="Safari Ball" 
              style={{ 
                width: '80px',
                height: '80px',
                imageRendering: 'pixelated',
                marginBottom: '16px'
              }} 
            />
            
            <h4 style={{ 
              fontSize: '18px', 
              marginBottom: '12px',
              color: '#ffe066'
            }}>
              Welcome to the Safari Zone!
            </h4>
            
            <p style={{ fontSize: '14px', lineHeight: '1.6', marginBottom: '16px' }}>
              For just 1,000 coins, you can explore the Safari Zone for 1 hour.
              <br /><br />
              The Safari Zone is home to many rare Pokémon that can't be found elsewhere.
              <br /><br />
              Your access will expire after 1 hour, and you'll be returned to the entrance.
            </p>
            
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '8px', 
              background: 'rgba(255, 193, 7, 0.2)', 
              padding: '8px 16px', 
              borderRadius: '8px',
              marginBottom: '16px'
            }}>
              <img src="/items/coin.png" alt="Coins" style={{ width: 24, height: 24 }} />
              <span style={{ fontWeight: 'bold' }}>1,000 coins</span>
            </div>
            
            <button
              onClick={handlePurchase}
              disabled={isLoading}
              style={{
                background: isLoading 
                  ? 'rgba(74, 85, 104, 0.5)' 
                  : 'linear-gradient(to bottom, #4a5568, #2d3748)',
                border: 'none',
                color: isLoading ? '#a0aec0' : '#fff',
                borderRadius: '4px',
                padding: '10px 20px',
                cursor: isLoading ? 'not-allowed' : 'pointer',
                transition: 'all 0.2s',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                fontSize: '16px',
                fontWeight: 'bold',
                width: '100%',
                maxWidth: '250px'
              }}
              onMouseOver={(e) => {
                if (!isLoading) {
                  e.target.style.background = 'linear-gradient(to bottom, #5a6978, #3d4758)';
                  e.target.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.3)';
                }
              }}
              onMouseOut={(e) => {
                if (!isLoading) {
                  e.target.style.background = 'linear-gradient(to bottom, #4a5568, #2d3748)';
                  e.target.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.2)';
                }
              }}
            >
              {isLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Processing...
                </>
              ) : (
                "Pay 1,000 coins"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SafariZoneModal;
